import { Injectable } from '@angular/core';

@Injectable()
export class IrrigationAdviceService {
  getColorByMinMax = (min, max, value): string => {
    if (min == null || max == null) {
      return '#b1b1b150';
    }
    if (value < min) {
      const netValue = min - value;
      if (netValue > 0 && netValue <= 2) {
        return '#D3B824';
      } else if (netValue > 2 && netValue <= 4) {
        return '#D5690C';
      } else if (netValue > 4 && netValue <= 6) {
        return '#F56A06';
      } else if (netValue > 6 && netValue <= 8) {
        return '#E6420C';
      } else if (netValue > 8) {
        return '#E6420C';
      }
    } else if (value > min && value < max) {
      return '#60C466';
    } else if (value > max) {
      const netValue = value - max;
      if (netValue > 0 && netValue <= 5) {
        return '#CAD8FF';
      } else if (netValue > 5 && netValue <= 10) {
        return '#6C8FEE';
      } else if (netValue > 10 && netValue <= 15) {
        return '#3D6EF6';
      } else if (netValue > 15 && netValue <= 20) {
        return '#134BE6';
      } else if (netValue > 20) {
        return '#134BE6';
      }
    }

    return '#b1b1b150';
  };
}
